import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

const AddressForm = ({ 
    countries, 
    states, 
    cities, 
    fetchStates, 
    fetchCities,
    isOwner
}) => {
    const { values, handleChange, errors, touched, setFieldValue } = useFormikContext();

    const handleCountryChange = (e) => {
        const countryId = e.target.value;
        handleChange(e);
        if (countryId) {
            fetchStates('address', countryId);
            setFieldValue('address.state_id', '');
            setFieldValue('address.city_id', '');
        }
    };

    const handleStateChange = (e) => {
        const stateId = e.target.value;
        handleChange(e);
        if (stateId) {
            fetchCities('address', stateId);
            setFieldValue('address.city_id', '');
        }
    };

    useEffect(() => {
        if (values.address?.country_id) {
            fetchStates('address', values.address.country_id);
        }
    }, []);

    return (
        <div style={{ 
            border: 'solid', 
            borderColor: 'lightgray', 
            padding: '30px', 
            marginBottom: '10px' 
        }}>
            <div className="row">
                <div className="col-md-4 mb-3">
                    <label className="form-label">Country</label>
                    <select
                        className={`form-control ${touched.address?.country_id && errors.address?.country_id ? 'is-invalid' : ''}`}
                        name="address.country_id"
                        value={values.address?.country_id || ""}
                        onChange={handleCountryChange}
                        disabled={!isOwner}
                    >
                        <option value="">Select a country</option>
                        {countries.map((country) => (
                            <option key={country.id} value={country.id}>
                                {country.name}
                            </option>
                        ))}
                    </select>
                    {touched.address?.country_id && errors.address?.country_id && (
                        <div className="invalid-feedback">{errors.address.country_id}</div>
                    )}
                </div>

                <div className="col-md-4 mb-3">
                    <label className="form-label">State</label>
                    <select
                        className={`form-control ${touched.address?.state_id && errors.address?.state_id ? 'is-invalid' : ''}`}
                        name="address.state_id"
                        value={values.address?.state_id || ""}
                        onChange={handleStateChange}
                        disabled={!values.address?.country_id || !isOwner}
                    >
                        <option value="">Select a state</option>
                        {states?.map((state) => (
                            <option key={state.id} value={state.id}>
                                {state.name}
                            </option>
                        ))}
                    </select>
                    {touched.address?.state_id && errors.address?.state_id && (
                        <div className="invalid-feedback">{errors.address.state_id}</div>
                    )}
                </div>

                <div className="col-md-4 mb-3">
                    <label className="form-label">City</label>
                    <select
                        className={`form-control ${touched.address?.city_id && errors.address?.city_id ? 'is-invalid' : ''}`}
                        name="address.city_id"
                        value={values.address?.city_id || ""}
                        onChange={handleChange}
                        disabled={!values.address?.state_id || !isOwner}
                    >
                        <option value="">Select a city</option>
                        {cities?.map((city) => (
                            <option key={city.id} value={city.id}>
                                {city.name}
                            </option>
                        ))}
                    </select>
                    {touched.address?.city_id && errors.address?.city_id && (
                        <div className="invalid-feedback">{errors.address.city_id}</div>
                    )}
                </div>
            </div>

            <div className="col-md-12 mb-3">
                <label className="form-label">Address</label>
                <input
                    type="text"
                    className={`form-control ${touched.address?.address && errors.address?.address ? 'is-invalid' : ''}`}
                    name="address.address"
                    value={values.address?.address || ""}
                    onChange={handleChange}
                    disabled={!isOwner}
                />
                {touched.address?.address && errors.address?.address && (
                    <div className="invalid-feedback">{errors.address.address}</div>
                )}
            </div>

            <div className="col-md-12 mb-3">
                <label className="form-label">Zip Code</label>
                <input
                    type="text"
                    className={`form-control ${touched.address?.zip_code && errors.address?.zip_code ? 'is-invalid' : ''}`}
                    name="address.zip_code"
                    value={values.address?.zip_code || ""}
                    onChange={handleChange}
                    disabled={!isOwner}
                />
                {touched.address?.zip_code && errors.address?.zip_code && (
                    <div className="invalid-feedback">{errors.address.zip_code}</div>
                )}
            </div>
        </div>
    );
};

export default AddressForm; 